import React from "react";
import "./Loader.css";
export default function Loader() {
  return (
    <div className="w-full h-[calc(100vh-130px)] flex items-center justify-center self-center text-center object-center">
      <div>
        <div className="container">
          <div className="box1"></div>
          <div className="box2"></div>
          <div className="box3"></div>
        </div>
      </div>
    </div>
  );
}
